import  { useState, useMemo, useEffect } from "react";
import { Platform } from 'react-native';

export const useIsInViewport = (ref:any) => {
    const [ isIntersecting, setIsIntersecting ] = useState(false);

  if(Platform.OS != 'web'){ return true }

  const observer = useMemo(
    () =>
      new IntersectionObserver(([entry]) => {
          if(!entry){ return }
          setIsIntersecting(entry.isIntersecting)
      },
      {
        rootMargin: '100px' // Trigger 100px before element enters viewport
      }
      ),
    [],
  );

  useEffect(() => {
    if(!ref?.current){ return }
    //if(Platform.OS != 'web'){ return }
    observer.observe(ref.current);

    // Check if already in viewport on mount
    const rect = ref.current.getBoundingClientRect();
    const isVisible = rect.top < window.innerHeight + 100 && rect.bottom > -100;
    if(isVisible) {
      setIsIntersecting(true);
    }

    return () => {
      observer.disconnect();
    };

  }, [ref, observer]);
  return isIntersecting;
}